import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index.tsx';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionPricingLlama',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean',
      defaultValue: true
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'Pricing Llama',
        options: {
          boxes: [
            {
              title: 'Fine-tune LLaMA2',
              subtitle:
                'Learn how to customize LLaMA2 with Scale by reading our free LLaMA2 fine-tuning cookbook.',
              bullets: [
                {
                  text: 'Free Cookbook to quickly get started fine-tuning LLAMA2'
                },
                {
                  text: 'Get LLAMA2 working on your data'
                }
              ],
              cta: {
                buttons: [
                  {
                    type: 'primary',
                    variant: 'default',
                    text: 'Learn More'
                  }
                ]
              },
              size: 'small'
            },
            {
              title: 'Free',
              subtitle:
                'Get started with our `llm-engine` open-source repository\nWith llm-engine you can customize and host open-source models in just a few lines of code with your data.',
              bullets: [
                {
                  text: 'Fine-tune and deploy LLaMA2, MPT, Falcon, FLAN-T5, GPT-J and more'
                },
                {
                  text: 'Host models on your infrastructure or Scale’s'
                }
              ],
              cta: {
                buttons: [
                  {
                    type: 'primary',
                    variant: 'default',
                    text: 'Learn More'
                  }
                ]
              },
              size: 'small'
            },
            {
              title: 'Enterprise',
              subtitle:
                'Scale Custom LLMs for your highest priority business use cases. Scale’s fine-tuning platform combined with the Scale data engine supercharges model performance with better data.',
              bullets: [
                {
                  text: 'White-glove support for building domain-specific LLMs'
                },
                {
                  text: 'Run on Scale Data Engine for optimized data and performance'
                },
                {
                  text: 'Get access to a full Evaluation Suite for model observability'
                }
              ],
              cta: {
                buttons: [
                  {
                    type: 'primary',
                    variant: 'default',
                    text: 'Get Started'
                  }
                ]
              },
              size: 'small'
            }
          ]
        }
      }
    }
  ]
});
